<ng-container *ngIf="!mobile else mobileversion">
    <div>
        <ul class="flx">
            <ng-container *ngFor="let mm of mymenu?.menu2?.menus; let k=index">
                <clever-menu2-item [menu]="mm" [deskmode]="deskmode"></clever-menu2-item>
            </ng-container>
            @if(partner?.partnerid === 'ferien-touristik') {
            <a multilang class="feriencorallogo" href="https://coraltravel.de">
                <img src="../../../../assets/images/corallogo.svg" height="20" width="auto" alt="Coral Travel">
            </a>
            }
        </ul>
    </div>
</ng-container>

<ng-template #mobileversion>
    <!-- </für google> -->
    <div class="hidden">
        <ng-container *ngFor="let mm of mymenu?.menu2?.menus; let k=index">
            <clever-menu2-item [menu]="mm" [deskmode]="deskmode"></clever-menu2-item>
        </ng-container>
    </div>
    <div class="cc1">
        <div class="menuItem">
            <ng-container *ngIf="mymenu?.menuHistory2.length > 1">
                <button class="cc2" (click)="gobackMenu($event)">
                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"
                        fill="#000000">
                        <path d="M0 0h24v24H0V0z" fill="none" />
                        <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z" />
                    </svg>
                </button>
            </ng-container>
            <div [class.pl5]="mymenu?.menuHistory2.length === 1">
                <span multilang>{{mymenu?.currentMenuName2}}</span>
            </div>
            <button (click)="closeMenuF()">
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path
                        d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                </svg>
            </button>
        </div>
        <mat-divider></mat-divider>

        <ng-container *ngIf="mymenu?.menuHistory2?.length > 0">
            <ng-container *ngFor="let gm of mymenu?.menuHistory2[mymenu?.menuHistory2.length - 1].menus">
                <ul class="mmmnu">
                    <ng-container *ngIf="!gm?.isItem else asitm">
                        <ng-container *ngIf="(gm?.column?.length > 0 || gm?.menus?.length > 0) else asitm">
                            <li multilang class="menuItem" (click)="opensubmenu(gm, $event)">
                                <span multilang>{{gm?.title}}</span>
                                <mat-icon class="cc2">keyboard_arrow_right</mat-icon>
                            </li>
                        </ng-container>
                    </ng-container>
                    <ng-template #asitm>
                        @if(gm.image?.length > 0) {
                        <li multilang class="menuItem">
                            <a multilang [href]="gm?.link" class="w100 item hlink">
                                <div class="menuimgwrp">
                                    <div class="menuimgbody">
                                        <img class="imgmenu" [src]="gm.image" alt="img">
                                    </div>
                                    <div class="menuinputwrp">
                                        <span multilang class="menuinputwrpspan">{{gm.title}}</span>
                                        <p multilang class="menuinputwrpp">{{gm.subtitle}}</p>
                                    </div>
                                </div>
                            </a>
                        </li>
                        } @else {
                        <li multilang class="menuItem">
                            <a multilang class="w100" [href]="gm.link">{{gm?.title}}</a>
                        </li>
                        }
                    </ng-template>
                    <mat-divider></mat-divider>
                </ul>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="mymenu?.menuHistory2?.length <= 1">
            @if(showTermin){
            <ul class="mmmnu">
                <li multilang class="menuItem" (click)="gotoCalendar()">
                    <span multilang>Termin</span>
                </li>
                <mat-divider></mat-divider>
            </ul>
            }
            @if(showChat){
            <ul class="mmmnu">
                <li multilang class="menuItem" (click)="openChat()">
                    <span multilang>Chat</span>
                </li>
                <mat-divider></mat-divider>
            </ul>
            }
            @if(showhReisekompass){
            <ul class="mmmnu">
                <li multilang class="menuItem" (click)="gotoContent()">
                    <span multilang>Reisekompass</span>
                </li>
                <mat-divider></mat-divider>
            </ul>
            }
            @if(showhLogin){
            <ng-container *ngIf="currentCustomer?.asPartner">
                <ul>
                    <li multilang class="menuItem" (click)="gotoOfferpack()">
                        <span multilang [matBadge]="offerpackCount > 0 ? offerpackCount : ''" matBadgePosition="after"
                            matBadgeOverlap="false" matBadgeColor="warn">Angebotsliste</span>
                    </li>
                    <mat-divider></mat-divider>
                </ul>
            </ng-container>
            }
            @if(showhDigbrater){
            <div>
                <button class="menuItem" (click)="gotoAnfrage()">
                    <span multilang>Digitaler Reiseberater</span>
                </button>
                <mat-divider></mat-divider>
            </div>
            }
        </ng-container>

        @if(partner?.partnerid === 'ferien-touristik') {
        <a multilang class="feriencorallogomobile" href="https://coraltravel.de">
            <img src="../../../../assets/images/coraltransparent.png" alt="Coral Travel">
        </a>
        }
    </div>
</ng-template>